export const leadershipCornerPageUrl = '/leadership-corner';
export const leadershipCornerFeaturedConversationsUrl = '/leadership-corner/featured-conversations';
